import { Link } from "react-router-dom";
import clsx from "clsx";
import type { ReactNode } from "react";

interface LogoProps {
  to?: string;
  className?: string;
  imgClassName?: string;
  altText?: string;
  children?: ReactNode;
}

export const Logo = ({
  to = "/",
  className,
  imgClassName = "h-7 w-auto",
  altText = "G&D Consulting",
  children,
}: LogoProps) => {
  return (
    <Link
      to={to}
      className={clsx(
        "inline-flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue/40 rounded-lg p-0.5 transition-all duration-200 hover:opacity-90 active:scale-[0.98]",
        className
      )}
    >
      <img
        src="/logo.svg"
        alt={altText}
        className={clsx(imgClassName, "select-none")}
      />
      {children}
    </Link>
  );
};
